<template>
  <div class="wh-search-input input-warp wh-flex-start">
    <el-input
      v-model="inputValue"
      :class="{'icon-select': !!icon, 'btn-show': btnShow}"
      :clearable="clearable"
      :placeholder="placeholder"
      @keyup.enter.native="searchFn"
      @input="inputFn"
    />
    <el-button
      v-if="btnShow"
      class="btn-search"
      type="primary"
      @click="searchFn"
    >
      <i v-if="btnIcon" :class="btnIcon" />
      <span v-else>搜索</span>
    </el-button>
    <i v-if="!!icon" class="left-icon" :class="icon" />
  </div>
</template>

<script>
export default {
  name: 'WhSearchInput',
  props: {
    /**
       * placeholder
       */
    placeholder: {
      type: String,
      default: () => {
        return '请输入内容'
      }
    },
    /**
       * clearable
       */
    clearable: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    /**
       * 双向值
       */
    value: {
      type: String,
      default: () => {
        return ''
      }
    },
    /**
       * left-icon,默认为''，样式自动变化
       */
    icon: {
      type: String,
      default: () => {
        return ''
      }
    },
    /**
       * 是否显示按钮
       */
    btnShow: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    btnIcon: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      inputValue: ''
    }
  },
  watch: {
    value: {
      handler(newV, oldV) {
        this.inputValue = newV
      },
      immediate: true
    }
  },
  created() {
    // this.inputValue = this.value
  },
  methods: {
    inputFn() {
      this.$emit('update:value', this.inputValue)
      // this.$emit('input', this.inputValue)
    },
    searchFn() {
      this.$emit('search', this.inputValue)
    }
  }
}
</script>

<style lang="less" scoped>
  .input-warp{
    position: relative;
    /deep/ .el-select{
      flex: 1;
    }
    /deep/ .el-input__inner{
      border-radius: 0;
      height: 34px;
      line-height: 34px;
      padding-right: 15px;
      &::-webkit-input-placeholder{
        font-size: 12px;
      }
    }
    /deep/ .btn-show .el-input__inner{
      border: none;
      background-color: #F1F1F1;
    }
    .btn-search{
      width: 48px;
      height: 34px;
      padding: 0 10px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    /deep/ .icon-select .el-input__inner{
      padding-left: 36px;
    }
    /deep/ .el-button{
      background-color: #508CEE;
      border-color: #508CEE;
    }
    .left-icon{
      color: #4F8CEE;
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translate(0, -50%);
    }
    /deep/ .el-input__icon{
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
